import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BusinessCardQueryParams } from '@warema/shared/company-search/models';
import { ENVIRONMENT, WaremaPlusEnvironment } from '@warema/shared/models';

@Pipe({
    name: 'businessCardUrlWithParams',
})
export class BusinessCardUrlWithParamsPipe implements PipeTransform {
    private readonly _environment = inject<WaremaPlusEnvironment>(ENVIRONMENT);
    private readonly _translationService = inject(TranslateService);

    private readonly _businessCardUrlPrefix: string;

    constructor() {
        this._businessCardUrlPrefix = `${this._environment.businessCardsUrl}/${this._translationService.getCurrentLang()}/`;
    }

    public transform(urlCityNameNo: string, queryParams: BusinessCardQueryParams | null): string {
        let url = '';
        if (queryParams === null) {
            return url;
        }
        const queryParamsMapped = this._computeQueryParams(queryParams);
        url = `${this._businessCardUrlPrefix}${urlCityNameNo}${queryParamsMapped}`;

        return url;
    }

    private _computeQueryParams(queryParams: BusinessCardQueryParams): string {
        const paramComponents: Array<string> = [];

        if (queryParams.productSubCategoriesIds) {
            paramComponents.push('productSubcategories=' + queryParams.productSubCategoriesIds.join(','));
        }

        if (queryParams.activity) {
            paramComponents.push('activity=' + queryParams.activity);
        }

        if (queryParams.searchAddress) {
            paramComponents.push('location=' + queryParams.searchAddress);
        }

        paramComponents.push(`origin=${queryParams.origin}`);
        return paramComponents.length > 0 ? `?${paramComponents.join('&')}` : '';
    }
}
